import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ITemplateLeadSummary, templateLeadSummariesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { getters } from './getters';

const TEMPLATE_LEAD_SUMMARY_MODULE = 'templateLeadSummary';

const dataObjectModule = getDataObjectsModule<ITemplateLeadSummary>(templateLeadSummariesManager, 3);
const searchModule = getSearchModule<ITemplateLeadSummary>(templateLeadSummariesManager);

const templateLeadSummaryModuleInstance = merge<unknown>(dataObjectModule, searchModule, { getters });
store.registerModule(TEMPLATE_LEAD_SUMMARY_MODULE, templateLeadSummaryModuleInstance);

export { TEMPLATE_LEAD_SUMMARY_MODULE };
